<template>
  <div v-show="isShow.isKVShow" class="pageKV">
    <Logo />
    <div class="preContainer" :style="startState ? 'display: block' : 'display: none'">
      <div class="preBg"></div>
      <div class="kv-moon">
        <img src="./kv_moon.png" alt="moon">
      </div>
      <div class="kv-bottom">
        <div class="kvb-people">
          <div class="people" :class="isStartAni ? 'slideOut' : ''"></div>
          <div class="car" :class="isStartAni ? 'moveCar' : ''"></div>
        </div>
        <div class="kvb-land">
          <div class="para">
            <img src="./kv_para.png" alt="desc">
          </div>
          <div class="btn" :class="isStartAni ? 'scaleIt' : ''" @click="_showNext">
            <img src="./kv_btn.png" alt="btn">
          </div>
        </div>
      </div>
    </div>
    <div class="pageOne" :style="startState ? 'visibility: hidden' : 'visibility: visible'" :class="hideVideo ? 'video-hide' : 'video-show'">
      <video
        class="pgo-myVideo"
        ref="myVideo"
        preload="auto"
        playsinline="true"
        webkit-playsinline="true"
        x5-video-player-type="h5"
        x5-video-orientation="portrait"
        poster="./pg1_bg.jpg"
        id="myVideo"
      >
        <source :src="videoURL" type="video/mp4">
      </video>
      <!-- <div class="pgo-btn pgo-btnStart" @click="_playVideo" v-show="isAndroid">播放</div>
      <div class="pgo-btn pgo-btnEnd" @click="_pauseVideo" v-show="isAndroid">暂停播放</div> -->
      <!--<toast :isToast="toastShow" :sNum="sceneNumber" :isToastNum="toastNumShow" @toastDirective="handleToast" @onEnter="handleEnter" @onGoOn="handleGoOn" />-->
      <div class="toastContainer slideInAni" v-show="toastShow" :style="showBgMask ? { background: 'rgba(0, 0, 0, .7)' } : ''">
        <div class="toastContent" v-show="toastNumShow === 1">
          <div class="content">
            <img :src="descSrc" alt="desc">
          </div>
          <div class="btns">
            <div class="btn1 btn" @click="enterIn">
              <img :src="btnSrc" alt="btn">
            </div>
            <div class="btn2 btn" @click="goOn">
              <img :src="goOnBtnSrc" alt="btn">
            </div>
          </div>
        </div>
        <div class="toastContent2 slideInAni" v-show="toastNumShow !== 1">
          <div class="content2Common" v-show="sceneNumber !== 1">
            <div class="cc_wrapper">
              <div v-if="sceneNumber === 3 || sceneNumber === 4">
                <div v-show="video3Show">
                <!--马龙 BEGIN-->
                <div class="andbox mlandbox" v-show="mobile">
                  <img src="./ml3109.png" />
                  <img src="./ml3108.png" />
                  <img src="./ml3107.png" />
                  <img src="./ml3106.png" />
                  <img src="./ml3105.png" />
                  <img src="./ml3104.png" />
                  <img src="./ml3103.png" />
                  <img src="./ml3102.png" />
                  <img src="./ml3101.png" />
                  <img src="./ml3100.png" />

                  <img src="./ml3099.png" />
                  <img src="./ml3098.png" />
                  <img src="./ml3097.png" />
                  <img src="./ml3096.png" />
                  <img src="./ml3095.png" />
                  <img src="./ml3094.png" />
                  <img src="./ml3093.png" />
                  <img src="./ml3092.png" />
                  <img src="./ml3091.png" />
                  <img src="./ml3090.png" />
                  
                  <img src="./ml3089.png" />
                  <img src="./ml3088.png" />
                  <img src="./ml3087.png" />
                  <img src="./ml3086.png" />
                  <img src="./ml3085.png" />
                  <img src="./ml3084.png" />
                  <img src="./ml3083.png" />
                  <img src="./ml3082.png" />
                  <img src="./ml3081.png" />
                  <img src="./ml3080.png" />

                  <img src="./ml3079.png" />
                  <img src="./ml3078.png" />
                  <img src="./ml3077.png" />
                  <img src="./ml3076.png" />
                  <img src="./ml3075.png" />
                  <img src="./ml3074.png" />
                  <img src="./ml3073.png" />
                  <img src="./ml3072.png" />
                  <img src="./ml3071.png" />
                  <img src="./ml3070.png" />

                  <img src="./ml3069.png" />
                  <img src="./ml3068.png" />
                  <img src="./ml3067.png" />
                  <img src="./ml3066.png" />
                  <img src="./ml3065.png" />
                  <img src="./ml3064.png" />
                  <img src="./ml3063.png" />
                  <img src="./ml3062.png" />
                  <img src="./ml3061.png" />
                  <img src="./ml3060.png" />

                  <img src="./ml3059.png" />
                  <img src="./ml3058.png" />
                  <img src="./ml3057.png" />
                  <img src="./ml3056.png" />
                  <img src="./ml3055.png" />
                  <img src="./ml3054.png" />
                  <img src="./ml3053.png" />
                  <img src="./ml3052.png" />
                  <img src="./ml3051.png" />
                  <img src="./ml3050.png" />

                  <img src="./ml3049.png" />
                  <img src="./ml3048.png" />
                  <img src="./ml3047.png" />
                  <img src="./ml3046.png" />
                  <img src="./ml3045.png" />
                  <img src="./ml3044.png" />
                  <img src="./ml3043.png" />
                  <img src="./ml3042.png" />
                  <img src="./ml3041.png" />
                  <img src="./ml3040.png" />

                  <img src="./ml3039.png" />
                  <img src="./ml3038.png" />
                  <img src="./ml3037.png" />
                  <img src="./ml3036.png" />
                  <img src="./ml3035.png" />
                  <img src="./ml3034.png" />
                  <img src="./ml3033.png" />
                  <img src="./ml3032.png" />
                  <img src="./ml3031.png" />
                  <img src="./ml3030.png" />

                  <img src="./ml3029.png" />
                  <img src="./ml3028.png" />
                  <img src="./ml3027.png" />
                  <img src="./ml3026.png" />
                  <img src="./ml3025.png" />
                  <img src="./ml3024.png" />
                  <img src="./ml3023.png" />
                  <img src="./ml3022.png" />
                  <img src="./ml3021.png" />
                  <img src="./ml3020.png" />

                  <img src="./ml3019.png" />
                  <img src="./ml3018.png" />
                  <img src="./ml3017.png" />
                  <img src="./ml3016.png" />
                  <img src="./ml3015.png" />
                  <img src="./ml3014.png" />
                  <img src="./ml3013.png" />
                  <img src="./ml3012.png" />
                  <img src="./ml3011.png" />
                  <img src="./ml3010.png" />

                  <img src="./ml3009.png" />
                  <img src="./ml3008.png" />
                  <img src="./ml3007.png" />
                  <img src="./ml3006.png" />
                  <img src="./ml3005.png" />
                  <img src="./ml3004.png" />
                  <img src="./ml3003.png" />
                  <img src="./ml3002.png" />
                  <img src="./ml3001.png" />
                  <img src="./ml3000.png" />
                </div>
                <video
                  class="videoOther"
                  id="ML"
                  ref="myVideo2"
                  :poster="personSrc"
                  preload="auto"
                  playsinline="true"
                  webkit-playsinline="true"
                  x5-video-player-type="h5"
                  x5-video-orientation="portrait"
                  v-show="!mobile"
                >
                  <source :src="videoMl" type="video/mp4">
                </video>
                <!--马龙 END-->
                </div>

                <div v-show="!video3Show">
                <!--杨澜 BEGIN-->
                <div class="andbox ylandbox" v-show="mobile">
                  <img src="./yl3103.png" />
                  <img src="./yl3102.png" />
                  <img src="./yl3101.png" />
                  <img src="./yl3100.png" />

                  <img src="./yl3099.png" />
                  <img src="./yl3098.png" />
                  <img src="./yl3097.png" />
                  <img src="./yl3096.png" />
                  <img src="./yl3095.png" />
                  <img src="./yl3094.png" />
                  <img src="./yl3093.png" />
                  <img src="./yl3092.png" />
                  <img src="./yl3091.png" />
                  <img src="./yl3090.png" />
                  
                  <img src="./yl3089.png" />
                  <img src="./yl3088.png" />
                  <img src="./yl3087.png" />
                  <img src="./yl3086.png" />
                  <img src="./yl3085.png" />
                  <img src="./yl3084.png" />
                  <img src="./yl3083.png" />
                  <img src="./yl3082.png" />
                  <img src="./yl3081.png" />
                  <img src="./yl3080.png" />

                  <img src="./yl3079.png" />
                  <img src="./yl3078.png" />
                  <img src="./yl3077.png" />
                  <img src="./yl3076.png" />
                  <img src="./yl3075.png" />
                  <img src="./yl3074.png" />
                  <img src="./yl3073.png" />
                  <img src="./yl3072.png" />
                  <img src="./yl3071.png" />
                  <img src="./yl3070.png" />

                  <img src="./yl3069.png" />
                  <img src="./yl3068.png" />
                  <img src="./yl3067.png" />
                  <img src="./yl3066.png" />
                  <img src="./yl3065.png" />
                  <img src="./yl3064.png" />
                  <img src="./yl3063.png" />
                  <img src="./yl3062.png" />
                  <img src="./yl3061.png" />
                  <img src="./yl3060.png" />

                  <img src="./yl3059.png" />
                  <img src="./yl3058.png" />
                  <img src="./yl3057.png" />
                  <img src="./yl3056.png" />
                  <img src="./yl3055.png" />
                  <img src="./yl3054.png" />
                  <img src="./yl3053.png" />
                  <img src="./yl3052.png" />
                  <img src="./yl3051.png" />
                  <img src="./yl3050.png" />

                  <img src="./yl3049.png" />
                  <img src="./yl3048.png" />
                  <img src="./yl3047.png" />
                  <img src="./yl3046.png" />
                  <img src="./yl3045.png" />
                  <img src="./yl3044.png" />
                  <img src="./yl3043.png" />
                  <img src="./yl3042.png" />
                  <img src="./yl3041.png" />
                  <img src="./yl3040.png" />

                  <img src="./yl3039.png" />
                  <img src="./yl3038.png" />
                  <img src="./yl3037.png" />
                  <img src="./yl3036.png" />
                  <img src="./yl3035.png" />
                  <img src="./yl3034.png" />
                  <img src="./yl3033.png" />
                  <img src="./yl3032.png" />
                  <img src="./yl3031.png" />
                  <img src="./yl3030.png" />

                  <img src="./yl3029.png" />
                  <img src="./yl3028.png" />
                  <img src="./yl3027.png" />
                  <img src="./yl3026.png" />
                  <img src="./yl3025.png" />
                  <img src="./yl3024.png" />
                  <img src="./yl3023.png" />
                  <img src="./yl3022.png" />
                  <img src="./yl3021.png" />
                  <img src="./yl3020.png" />

                  <img src="./yl3019.png" />
                  <img src="./yl3018.png" />
                  <img src="./yl3017.png" />
                  <img src="./yl3016.png" />
                  <img src="./yl3015.png" />
                  <img src="./yl3014.png" />
                  <img src="./yl3013.png" />
                  <img src="./yl3012.png" />
                  <img src="./yl3011.png" />
                  <img src="./yl3010.png" />

                  <img src="./yl3009.png" />
                  <img src="./yl3008.png" />
                  <img src="./yl3007.png" />
                  <img src="./yl3006.png" />
                  <img src="./yl3005.png" />
                  <img src="./yl3004.png" />
                  <img src="./yl3003.png" />
                  <img src="./yl3002.png" />
                  <img src="./yl3001.png" />
                  <img src="./yl3000.png" />
                </div>
                <video
                  class="videoOther videoOther2"
                  id="YL"
                  ref="myVideo3"
                  :poster="personSrc"
                  preload="auto"
                  playsinline="true"
                  webkit-playsinline="true"
                  x5-video-player-type="h5"
                  x5-video-orientation="portrait"
                  v-show="!mobile"
                >
                  <source :src="videoYl" type="video/mp4">
                </video>
                <!--杨澜 END-->
                </div>
              </div>

              <img :src="personSrc" alt="person" v-else>
              <div class="cc_titleWrapper">
                <img :src="titleSrc" alt="name">
              </div>
            </div>
            <div class="cc_desc">
              <img :src="desc2Src" alt="desc">
            </div>
            <div class="cc_btn" @click="goOn">
              <img :src="goOnBtnSrc" alt="btn">
            </div>
          </div>
          <div class="content2Unique" v-show="sceneNumber === 1">
            <div class="cu_content">
              <div class="cuc_left">
                <!--马未都 BEGIN-->
                <div class="andbox maandbox" v-show="mobile">
                  <img src="./ma294.png" />
                  <img src="./ma293.png" />
                  <img src="./ma292.png" />
                  <img src="./ma291.png" />
                  <img src="./ma290.png" />

                  <img src="./ma289.png" />
                  <img src="./ma288.png" />
                  <img src="./ma287.png" />
                  <img src="./ma286.png" />
                  <img src="./ma285.png" />
                  <img src="./ma284.png" />
                  <img src="./ma283.png" />
                  <img src="./ma282.png" />
                  <img src="./ma281.png" />
                  <img src="./ma280.png" />

                  <img src="./ma279.png" />
                  <img src="./ma278.png" />
                  <img src="./ma277.png" />
                  <img src="./ma276.png" />
                  <img src="./ma275.png" />
                  <img src="./ma274.png" />
                  <img src="./ma273.png" />
                  <img src="./ma272.png" />
                  <img src="./ma271.png" />
                  <img src="./ma270.png" />

                  <img src="./ma269.png" />
                  <img src="./ma268.png" />
                  <img src="./ma267.png" />
                  <img src="./ma266.png" />
                  <img src="./ma265.png" />
                  <img src="./ma264.png" />
                  <img src="./ma263.png" />
                  <img src="./ma262.png" />
                  <img src="./ma261.png" />
                  <img src="./ma260.png" />

                  <img src="./ma259.png" />
                  <img src="./ma258.png" />
                  <img src="./ma257.png" />
                  <img src="./ma256.png" />
                  <img src="./ma255.png" />
                  <img src="./ma254.png" />
                  <img src="./ma253.png" />
                  <img src="./ma252.png" />
                  <img src="./ma251.png" />
                  <img src="./ma250.png" />

                  <img src="./ma249.png" />
                  <img src="./ma248.png" />
                  <img src="./ma247.png" />
                  <img src="./ma246.png" />
                  <img src="./ma245.png" />
                  <img src="./ma244.png" />
                  <img src="./ma243.png" />
                  <img src="./ma242.png" />
                  <img src="./ma241.png" />
                  <img src="./ma240.png" />

                  <img src="./ma239.png" />
                  <img src="./ma238.png" />
                  <img src="./ma237.png" />
                  <img src="./ma236.png" />
                  <img src="./ma235.png" />
                  <img src="./ma234.png" />
                  <img src="./ma233.png" />
                  <img src="./ma232.png" />
                  <img src="./ma231.png" />
                  <img src="./ma230.png" />

                  <img src="./ma229.png" />
                  <img src="./ma228.png" />
                  <img src="./ma227.png" />
                  <img src="./ma226.png" />
                  <img src="./ma225.png" />
                  <img src="./ma224.png" />
                  <img src="./ma223.png" />
                  <img src="./ma222.png" />
                  <img src="./ma221.png" />
                  <img src="./ma220.png" />

                  <img src="./ma219.png" />
                  <img src="./ma218.png" />
                  <img src="./ma217.png" />
                  <img src="./ma216.png" />
                  <img src="./ma215.png" />
                  <img src="./ma214.png" />
                  <img src="./ma213.png" />
                  <img src="./ma212.png" />
                  <img src="./ma211.png" />
                  <img src="./ma210.png" />

                  <img src="./ma209.png" />
                  <img src="./ma208.png" />
                  <img src="./ma207.png" />
                  <img src="./ma206.png" />
                  <img src="./ma205.png" />
                  <img src="./ma204.png" />
                  <img src="./ma203.png" />
                  <img src="./ma202.png" />
                  <img src="./ma201.png" />
                  <img src="./ma200.png" />
                </div>
                <video
                  class="videoMa"
                  ref="myVideo1"
                  :poster="personSrc"
                  preload="auto"
                  playsinline="true"
                  webkit-playsinline="true"
                  x5-video-player-type="h5"
                  x5-video-orientation="portrait"
                  v-show="!mobile"
                  id="myVideo1"
                >
                  <source :src="videoMa" type="video/mp4">
                </video>
                <!--马未都 END-->
                <div class="cuc_left-title"></div>
              </div>
              <div class="cuc_right">
                <img :src="desc2Src" alt="desc">
              </div>
            </div>
            <div class="cu_btn" @click="goOn">
              <img :src="goOnBtnSrc" alt="btn">
            </div>
          </div>
        </div>
      </div>




    </div>

    <audio :src="voice2" id="m02" preload="preload" />
    <audio :src="voice5" id="m05" preload="preload" />
    <audio :src="voice6" id="m06" preload="preload" />

    <!--适配安卓机使用的音频 BEGIN-->
    <audio :src="voice1" id="andm01" preload="preload" />
    <audio :src="voice3" id="andm03" preload="preload" />
    <audio :src="voice4" id="andm04" preload="preload" />
    <!--适配安卓机使用的音频 END-->
  </div>
</template>

<script>
import Logo from '../../components/logo/logo'
//import Toast from '../../components/toast/toast'
import $ from "jquery";

export default {
  name: 'PageKV',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      isStartAni: false,
      /*****/
      videoURL: "https://www.jiandoukeji.com/h5/2018/audizq/media/v10.mp4",
      toastShow: false, // 是否显示弹窗
      toastNumShow: 1, // 弹窗序号 共2个
      sceneNumber: 1, // 场景序号 共6个
      /** 新增 */
      startState: true, // 视频和KV的显隐关系
      hideVideo: false, // 视频播放完毕的状态，解决安卓机型视频播完之后不能自动退出的问题
      btn1Clicked: false,
      btn2Clicked: false,
      videoMa: 'https://www.jiandoukeji.com/h5/2018/audizq/media/ma2.mp4',
      videoMl: 'https://www.jiandoukeji.com/h5/2018/audizq/media/ml3.mp4',
      videoYl: 'https://www.jiandoukeji.com/h5/2018/audizq/media/yl3.mp4',
      video3Show: true,
      mobile:false,
      setAndFalg:null,
      voice5: 'https://www.jiandoukeji.com/h5/2018/audizq/media/zhangyadong.mp3',
      voice2: 'https://www.jiandoukeji.com/h5/2018/audizq/media/jsy.mp3',
      voice6: 'https://www.jiandoukeji.com/h5/2018/audizq/media/huangxuan2.mp3',
      voice1: 'https://www.jiandoukeji.com/h5/2018/audizq/media/ma-1-android.mp3', //马未都
      voice3: 'https://www.jiandoukeji.com/h5/2018/audizq/media/yl-1-android.mp3', //马龙
      voice4: 'https://www.jiandoukeji.com/h5/2018/audizq/media/ml-1-android.mp3', //杨澜
    }
  },
  components: {
    Logo
  },
  methods: {
    _showNext () {
      // 安卓机型直接进行视频的播放
      this.isStartAni = true
      if (this.mobile) {
        this._playVideo()
        this.startState = false
      } else {
        setTimeout(() => {
          this.startState = false
        }, 2200)
        setTimeout(() => {
          this._playVideo()
        }, 2000)
      }
    },
    /****/
    isAndroid () {
      const ua = window.navigator.userAgent
      return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
    },
    hvPlay (data) {
      let musicName = data
      let audio = document.getElementById(musicName)
      audio.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play()
      }, false)
    },
    _initMusic (id) {
      let audio = document.getElementById(id)
      // audio.volume = 0
      audio.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play()
      }, false)

      setTimeout(() => {
        audio.pause()
        document.addEventListener('WeixinJSBridgeReady', function () {
          audio.pause()
        }, false)
      }, 200)
    },
    enterIn () {
      const _this=this
      
      this.btn1Clicked = true
      setTimeout(() => {
        //this.$emit('onEnter', {sN: this.sceneNumber, tNum: this.toastNumShow})
        //const { sN, tNum } = msg
        this.toastNumShow = 2
        if(!_this.mobile){
          this.$emit('toggleBgm', this.sceneNumber)
        }
        
        this.btn1Clicked = false



        if (this.sceneNumber === 1) {
          //马未都 视频video ************
          if(!_this.mobile){
            //ios
            _this._playVideo1()
          }else{
            //andriod
            //19秒
            let picsnum=95 //图片张数 修改
            let durtime=19000/picsnum
            _this.androidShow('maandbox',picsnum,durtime)
            
            _this.hvPlay('andm01')
    
          }
        } else if (this.sceneNumber === 2){
          //江疏影 音频
          //this.$emit('hvDirective', { name: 'm02' })
          _this.hvPlay('m02')
        } else if (this.sceneNumber === 3) {
          //马龙 视频video ************
          if(!_this.mobile){
            //ios
            _this._playVideo2()
          }else{
            //andriod
            //22秒04
            let picsnum=110 //图片张数 修改
            let durtime=22040/picsnum
            _this.androidShow('mlandbox',picsnum,durtime)
            //_this.$emit('hvDirective', { name: 'andm04' })
            _this.hvPlay('andm04')
          }
        } else if (this.sceneNumber === 4) {
          //杨澜 视频video ************
          this.video3Show = false
          if(!_this.mobile){
            //ios
            _this._playVideo3()
          }else{
            //andriod
            //20秒24
            let picsnum=104 //图片张数 修改
            let durtime=20240/picsnum
            _this.androidShow('ylandbox',picsnum,durtime)
            //_this.$emit('hvDirective', { name: 'andm03' })
            _this.hvPlay('andm03')
          }
        } else if (this.sceneNumber === 5) {
          //张亚东 音频
          //this.$emit('hvDirective', {name: 'm05'})
          _this.hvPlay('m05')
        } else if (this.sceneNumber === 6) {
          //黄轩 音频
          //this.$emit('hvDirective', {name: 'm06'})
          _this.hvPlay('m06')
        }


      }, 200)
    },
    androidShow(className,max,time){
      //安卓机展示序列图
      let pics=$('.'+className+' img')
      let squ=max-1
      
      const _this=this
      clearInterval(this.setAndFalg)

      this.setAndFalg=setInterval(()=>{
        pics.eq(squ).hide()
        squ--
        if(squ<=0){
          clearInterval(_this.setAndFalg)
        }

      },time)
    },
    goOn () {
      this.btn2Clicked = true
      //const videoEle = document.getElementById('ML')
      const _this=this


      

      setTimeout(() => {
        
        _this._playVideo()
        
        //_this.$emit('onGoOn', { sN: this.sceneNumber, tNum: this.toastNumShow })

        _this.$emit('goOnPlay')
        const videoEle = document.getElementById('myVideo')
        videoEle.currentTime += 2
        
        _this.toastShow = false
        _this.toastNumShow = 1
        if (_this.sceneNumber < 6) {
          _this.sceneNumber += 1
        }

        _this.btn2Clicked = false
        if(!_this.mobile){
          if (_this.sceneNumber === 1) {
            _this._pauseVideo1()
          } else if (_this.sceneNumber === 3) {
            _this._pauseVideo2()
          } else if (this.sceneNumber === 4) {
            _this._pauseVideo3()
          }
        }
      }, 200)
    },
    _playVideo () {
      //const videoEle = this.$refs.myVideo
      const videoEle = document.getElementById('myVideo')
      //alert(videoEle.currentTime)
      videoEle.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.play()
      }, false)
    },
    _playVideo1 () {
      const videoEle = this.$refs.myVideo1
      videoEle.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.play()
      }, false)
    },
    _playVideo2 () {
      const videoEle = this.$refs.myVideo2
      videoEle.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.play()
      }, false)
    },
    _playVideo3 () {
      const videoEle = this.$refs.myVideo3
      videoEle.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.play()
      }, false)
    },
    _pauseVideo () {
      //const videoEle = this.$refs.myVideo
      const videoEle = document.getElementById('myVideo')
      videoEle.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.pause()
      }, false)
    },
    _pauseVideo1 () {
      const videoEle = this.$refs.myVideo1
      videoEle.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.pause()
      }, false)
    },
    _pauseVideo2 () {
      const videoEle = this.$refs.myVideo2
      videoEle.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.pause()
      }, false)
    },
    _pauseVideo3 () {
      const videoEle = this.$refs.myVideo3
      videoEle.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.pause()
      }, false)
    }

  },
  computed: {
    btnSrc () {
      const num = this.sceneNumber
      return this.btn1Clicked ? require(`./cm_s${num}-slc1-a.png`) : require(`./cm_s${num}-slc1-u.png`)
    },
    goOnBtnSrc () {
      return this.btn2Clicked ? require('./cm_slc2-a.png') : require('./cm_slc2-u.png')
    },
    personSrc () {
      const num = this.sceneNumber
      return require(`./cm_person${num}.jpg`)
    },
    descSrc () {
      const num = this.sceneNumber
      return require(`./cm_s${num}-desc.png`)
    },
    desc2Src () {
      const num = this.sceneNumber
      return require(`./s${num}_bgDesc.png`)
    },
    titleSrc () {
      const num = this.sceneNumber
      return require(`./cm_title${num}.png`)
    },
    showBgMask () {
      return this.toastNumShow === 2
    },
    calVideo () {
      return this.sceneNumber === 3 ? this.videoMl : this.videoYl
    }
  },
  mounted () {
    this.mobile=this.isAndroid()

    const audioList = ['m02', 'm05', 'm06','andm01','andm03','andm04']
    audioList.forEach((item) => {
      this._initMusic(item)
    })

    const videoEle = document.getElementById('myVideo')
    document.addEventListener("WeixinJSBridgeReady", function () {
      videoEle.play()
      videoEle.pause()
    }, false)

    const _this = this
    videoEle.addEventListener('timeupdate', function () {
      const currentTime = videoEle.currentTime
      console.log('当前播放时间：', + currentTime)
      const condition = (currentTime > 3 && currentTime < 4) || (currentTime > 9 && currentTime < 10 )
        || (currentTime > 16 && currentTime < 17) || (currentTime > 21 && currentTime < 22)
        || (currentTime > 32 && currentTime < 33) || (currentTime > 40 && currentTime < 41)
      if (condition) {
        _this._pauseVideo()
        _this.toastShow = true
      }
    })

    videoEle.addEventListener('canplaythrough', function () {
      console.log('canplaythrough')
      console.log(videoEle.duration)
    })

    videoEle.addEventListener('ended', function () {
      console.log('播放事件: ended')
      _this.$props.isShow.isPTShow = true
      _this.$props.isShow.isKVShow = false
      _this.hideVideo = true
      _this.$emit('gogame')
    })
  }
}
</script>

<style lang="less" scoped>
.pageKV {
  width: 100%;
  height: 100%;
  background: linear-gradient(#0e132a, #0f1c41 40%, #354a6e 80%);
  .preBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 21.8125rem /* 349/16 */;
    background-image: url(./kv_bg.png);
    background-size: 100% 100%;
  }
  .kv-moon {
    position: absolute;
    left: 50%;
    overflow: hidden;
    width: 31.25rem /* 500/16 */;
    height: 31.25rem /* 500/16 */;
    transform-origin: center;
    transform: scale(.8) translate(-20rem /* 320/16 */,  -5rem /* 80/16 */);
    img {
      width: 100%;
    }
  }
  .kv-bottom {
    position: absolute;
    bottom: 0;
    .kvb-people {
      position: relative;
      .people {
        position: absolute;
        top: -2.25rem /* 36/16 */;
        width: 10.78125rem /* 172.5/16 */;
        height: 10.46875rem /* 167.5/16 */;
        background-image: url(./kv_people.png);
        background-size: 100% 100%;
      }
      .car {
        position: absolute;
        top: -.375rem /* 6/16 */;
        right: 2.5rem /* 40/16 */;
        width: 8.75rem /* 140/16 */;
        height: 6.59375rem /* 105.5/16 */;
        background-image: url(./kv_car.png);
        background-size: 100% 100%;
      }
    }
    .kvb-land {
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      padding-top: 6.25rem /* 100/16 */;
      width: 23.4375rem /* 375/16 */;
      height: 20.21875rem /* 323.5/16 */;
      background-image: url(./kv_land.png);
      background-size: 100% 100%;
      .para {
        width: 10.125rem /* 162/16 */;
        height: 5.625rem /* 90/16 */;
        img {
          width: 100%;
        }
      }
      .btn {
        margin-top: 2.5rem /* 40/16 */;
        width: 120px;
        height: 2rem /* 32/16 */;
        img {
          width: 100%;
        }
      }
    }
  }
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .kv-moon {
      transform: scale(1) translate(-15.625rem /* 250/16 */,  -1.875rem /* 30/16 */);
    }
  }
}

.moveCar {
  animation: moveCar 1s ease-in;
  animation-fill-mode: both;
  animation-delay: 1s;
}

@keyframes moveCar {
  0% {
    transform-origin: center;
    transform: translate();
  }
  100% {
    transform-origin: center;
    transform: translate(11.25rem /* 180/16 */, .625rem /* 10/16 */)
  }
}

.slideOut {
  animation: slideOut 1s linear;
  animation-fill-mode: both;
}

@keyframes slideOut {
  0% {
    filter: opacity(1)
  }
  100% {
    filter: opacity(0)
  }
}

.scaleIt {
  animation: scaleIt .4s linear;
  transform-origin: center;
  animation-fill-mode: both;
}

@keyframes scaleIt {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(.96);
  }
}

.pageOne {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(./pg1_bg.jpg);
  background-size: 100% 100%;
  .pgo-myVideo {
    width: 100%;
  }
  .pgo-btn {
    position: absolute;
    left: 50%;
    top: 0;
    width: 5rem /* 80/16 */;
    height: 1.875rem /* 30/16 */;
    line-height: 1.875rem /* 30/16 */;
    text-align: center;
    background-color: transparent;
    color: #fff;
    border-radius: .375rem /* 6/16 */;
    border: 1px solid #fff;
  }
  .pgo-btnStart {
    transform: translate(-3.75rem /* 60/16 */, 2.5rem /* 40/16 */);
  }
  .pgo-btnEnd {
    transform: translate(2.5rem /* 40/16 */, 2.5rem /* 40/16 */);
  }
}

.video-show {
  display: block;
  z-index: 0;
}

.video-hide {
  display: none;
  z-index: -1;
}


.andbox{
  position: relative;
  width: 100%;
  height: 100%;
  img{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
.toastContainer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // background: rgba(0, 0, 0, .7);
  .toastContent {
    position: absolute;
    box-sizing: border-box;
    padding: 6.25rem /* 100/16 */ 1.875rem /* 30/16 */ 1.25rem /* 20/16 */ 1.875rem /* 30/16 */;
    left: 50%;
    top: 40%;
    transform: translate(-11.71875rem /* 187.5/16 */, -8.25rem /* 132/16 */);
    width: 23.4375rem /* 375/16 */;
    height: 16.4375rem /* 263/16 */;
    background-image: url(./cm_toast.png);
    background-size: 100% 100%;
    .content {
      margin: 3.125rem /* 50/16 */ 0 1.875rem /* 30/16 */;
      width: 19.5rem /* 312/16 */;
      height: 1rem /* 16/16 */;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 100%;
      }
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 1.875rem /* 30/16 */;
      .btn {
        width: 6.75rem /* 108/16 */;
        height: 1.78125rem /* 28.5/16 */;
        img {
          width: 100%;
        }
      }
    }
  }
  .toastContent2 {
    position: absolute;
    box-sizing: border-box;
    top: 48%;
    left: 50%;
    margin-top: -18.25rem /* 292/16 */;
    margin-left: -11.71875rem /* 187.5/16 */;
    padding: 9.375rem /* 150/16 */ 1.25rem /* 20/16 */ 3.125rem /* 50/16 */;
    width: 23.4375rem /* 375/16 */;
    height: 36.4375rem /* 583/16 */;
    background-size: 100% 100%;
    background-image: url(./s1_bg.png);
    .content2Common {
      .cc_wrapper {
        position: relative;
        box-sizing: border-box;
        width: 21.0625rem /* 337/16 */;
        height: 12rem /* 192/16 */;
        border: 1px solid #eee8ab;
        padding: .125rem /* 2/16 */;
        margin: .625rem /* 10/16 */ 0;
        img {
          width: 100%;
        }
        .videoOther {
          width: 100%;
          height: 100%;
        }
        .cc_titleWrapper {
          position: absolute;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          box-sizing: border-box;
          padding-left: .375rem /* 6/16 */;
          width: 20.625rem /* 330/16 */;
          height: 1.75rem /* 28/16 */;
          background-image: url(./cm_titleBg.png);
          background-size: 100% 100%;
          img {
            height: 1.09375rem /* 17.5/16 */;
            width: auto;
          }
        }
      }
      .cc_desc {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        width: 19.75rem /* 316/16 */;
        height: 7.9375rem /* 127/16 */;
        img {
          width: 100%;
        }
      }
      .cc_btn {
        display: flex;
        justify-content: flex-end;
        box-sizing: border-box;
        padding-right: .625rem /* 10/16 */;
        width: 100%;
        height: 1.6875rem /* 27/16 */;
        img {
          height: 100%;
        }
      }
    }
    .content2Unique {
      .cu_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .375rem /* 6/16 */;
        margin: 1.25rem /* 20/16 */ 0 0;
        .cuc_left {
          position: relative;
          box-sizing: border-box;
          width: 10rem /* 160/16 */;
          height: 17.5rem /* 280/16 */;
          border: 1px solid #eee8ab;
          padding: .125rem /* 2/16 */;
          .videoMa {
            width: 100%;
          }
          .cuc_left-title {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 9.625rem /* 154/16 */;
            height: 2.75rem /* 44/16 */;
            background-image: url(./cm_titleBg2.png);
            background-size: 100% 100%;
          }
        }
        .cuc_right {
          width: 9.0625rem /* 145/16 */;
          height: 17.03125rem /* 272.5/16 */;
          img {
            width: 100%;
          }
        }
      }
      .cu_btn {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        box-sizing: border-box;
        width: 100%;
        height: 1.78125rem /* 28.5/16 */;
        margin-top: 2.5rem /* 40/16 */;
        padding-right: .625rem /* 10/16 */;
       img {
          height: 100%;
        }
      }
    }
  }
}

.slideInAni {
  animation: slideIn .2s ease-in;
  animation-fill-mode: both;
}

@keyframes slideIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
